import React, {CSSProperties, MutableRefObject, ReactNode, useRef} from 'react';
import styles from './CLTooltipOnOverflow.module.scss';
import classNames from 'classnames';
import CLTooltip, {CLTooltipProps} from '../CLTooltip/CLTooltip';
import useIsOverflowRef from '../../../../hooks/useIsOverfowRef';

export interface CLTooltipOnOverflowProps extends Omit<CLTooltipProps, 'popper'> {
  children: ReactNode;
  overrideChildrenPopoverContent?: ReactNode;
  style?: CSSProperties;
  contentClassName?: string;
  containerClassName?: string;
  lineClamp?: number;
  showOnHeightOverflow?: boolean;
  showOnWidthOverflow?: boolean;
}

function CLTooltipOnOverflow({
  children,
  overrideChildrenPopoverContent,
  placement = 'top',
  style,
  contentClassName = '',
  containerClassName,
  lineClamp = 1,
  showOnHeightOverflow = false,
  showOnWidthOverflow = true,
  ...props
}: CLTooltipOnOverflowProps) {
  const contRef = useRef<HTMLDivElement>(null);
  const {isWidthOverflow, isHeightOverflow} = useIsOverflowRef(
    contRef as MutableRefObject<HTMLDivElement>,
  );

  return (
    <CLTooltip
      placement={placement}
      tooltipShown={
        (isWidthOverflow && showOnWidthOverflow) || (isHeightOverflow && showOnHeightOverflow)
          ? undefined
          : false
      }
      popper={<span style={style}>{overrideChildrenPopoverContent || children}</span>}
      fitContent={false}
      triggerClassName={classNames(styles.trigger, containerClassName)}
      {...props}
    >
      <div
        ref={contRef}
        className={classNames(styles.ellipsis, {[styles.clamped]: lineClamp > 1})}
        style={{'--line_clamp': lineClamp} as CSSProperties}
      >
        <span className={classNames(contentClassName)}>{children}</span>
      </div>
    </CLTooltip>
  );
}

export default CLTooltipOnOverflow;
